module.exports = __webpack_public_path__ + "img/jia_xiang_hui.c6e58e16.png";